import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { GridColDef, GridPaginationModel } from '@mui/x-data-grid';
import { transformDateString } from '@/utilities/datetime';
import Container from '@/components/molecules/section/Container';
import Table from '@/components/molecules/section/Table';
import { useDsaReport } from '@/hooks/common';

const defaultPageSize = 5;

const DsaReport: React.FC<{ itemId?: number; clientId?: number }> = ({ itemId, clientId }) => {
  const { t } = useTranslation();
  const dsaReports = useDsaReport(itemId, clientId);
  const [pageSize, setPageSize] = useState(defaultPageSize);
  const [page, setPage] = useState(1);

  const columns: GridColDef[] = [
    { field: 'id', headerName: t('dsa_report.ticket_id') },
    { field: 'decisionDate', headerName: t('dsa_report.decision_date') },
    { field: 'decision', headerName: t('dsa_report.decision') },
    { field: 'reason', headerName: t('dsa_report.reason') },
  ];
  const rows =
    dsaReports.kind === 'Loaded'
      ? dsaReports.data.slice((page - 1) * pageSize, page * pageSize).map((report) => ({
          decisionDate: transformDateString(report.datetimeDecisionUtc) || '-',
          decision: report.reportDecision || '-',
          reason: report.reportReason || '-',
          id: report.idTicket || '-',
        }))
      : [];

  const onPageChange = ({ page, pageSize }: GridPaginationModel) => {
    setPage(page + 1);
    setPageSize(pageSize);
  };
  return (
    <Container
      title={t('dsa_report.title')}
      actions={[]}
      testId="dsa_report"
    >
      <Table
        rows={rows}
        columns={columns}
        loading={dsaReports.kind === 'Called' && dsaReports.fetching}
        table={{
          kind: 'DynamicTable',
          totalItem: dsaReports.kind === 'Loaded' ? dsaReports.data.length : 0,
          pageSize,
          pageSizeOptions: [defaultPageSize, 10, 15, 20],
          onPageChange,
        }}
      />
    </Container>
  );
};

export default DsaReport;
